import { assign, literal, object, omit, string } from 'superstruct';
import { CNodePropsTypeEnum } from '../const/schema';
import { CNodeDataStructDescribe, CNodeDataType } from './node';

export enum InnerComponentNameEnum {
  ROOT_CONTAINER = 'RootContainer',
}

export type CRootNodeDataType<ExtraT = any> = CNodeDataType<ExtraT> & {
  componentName: InnerComponentNameEnum | `${InnerComponentNameEnum}`;
};

export const FunctionPropertyTypeDescribe = object({
  type: literal(CNodePropsTypeEnum.FUNCTION),
  value: string(),
});

export const CRootNodeDataTypeDescribe = assign(
  omit(CNodeDataStructDescribe, ['componentName']),
  object({
    componentName: literal(InnerComponentNameEnum.ROOT_CONTAINER),
  })
);
